const getRefId = (queryString) => {
  const params = new URLSearchParams(queryString);
  return params.get('ref_id');
};

export default getRefId;
